export function formatBytes(value: string): string {
  const bytes = Number(value)
  if (!Number.isFinite(bytes) || bytes <= 0) return '—'
  const gb = bytes / 1024 ** 3
  if (gb >= 1) return `${gb.toFixed(2)} GB`
  return `${(bytes / 1024 ** 2).toFixed(0)} MB`
}

export function shortDate(iso: string): string {
  return iso.slice(5, 10).replace('-', '.')
}

export function dotDate(iso: string): string {
  return iso.slice(0, 10).replaceAll('-', '.')
}

const TONES = [
  '#2B2340',
  '#3A2236',
  '#1F2B3A',
  '#33283F',
  '#24303A',
  '#3B2A2A',
  '#2A2A3E',
  '#30233A',
  '#1E2E33',
  '#382536',
]

export function toneFor(key: string): string {
  let h = 0
  for (let i = 0; i < key.length; i += 1) h = (h * 31 + key.charCodeAt(i)) >>> 0
  return TONES[h % TONES.length] as string
}
